import React from 'react'
import { withTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import Header from '../components/Headers/Header'
import MessageOfTheDayConfiguration from '../components/Configuration/MessageOfTheDay/MessageOfTheDay'
import DeliveryRateConfiguration from '../components/Configuration/DeliveryRate/DeliveryRate'
import StoreCharges from '../components/Configuration/StoreCharges/StoreCharges'
import DistanceCharges from '../components/Configuration/DistanceCharges/DistanceCharges'

const Marketing = () => {
  return (
    <>
      <Header />
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12} lg={6}>
          <DeliveryRateConfiguration />
        </Grid>
        <Grid item xs={12} lg={6}>
          <MessageOfTheDayConfiguration />
        </Grid>
        <Grid item xs={12} lg={6}>
          <StoreCharges />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DistanceCharges />
        </Grid>
      </Grid>
    </>
  )
}

export default withTranslation()(Marketing)
